import Box, { BoxProps } from '@sendsprint/ui-react/dist/components/Box';
import React, { PropsWithChildren } from 'react';
import { FC } from 'react';
import cs from 'classnames';
// import './Container.css';

type ContainerProps = PropsWithChildren<{
  className?: string;
  variant?: 'fluid' | 'normal';
}> &
  BoxProps;
const Container: FC<ContainerProps> = ({ children, className, variant = 'normal', ...props }) => {
  return (
    // <Box {...props} className={`ss-container-component ss-container ${className ?? ''}`}>
    //   {children}
    // </Box>
    <Box
      {...props}
      className={cs('ss-mx-auto !ss-w-[90%]', {
        [`${className}`]: className,
        'ss-max-w-[1280px]': variant === 'normal',
        'ss-max-w-[1800px]': variant === 'fluid'
      })}>
      {children}
    </Box>
  );
};

export default Container;
